module.exports = __webpack_public_path__ + "static/media/COS_TOOLS_2.c3e3cf41.jpg";